( function () {
	'use strict';

	function MathService ( formulaService, $timeout, ERROR_MSGS ) {
		var self = this;

		function getMath ( key ) {
			return self.model.filter( function ( math ) {
				return math.key === key;
			} )[ 0 ];
		}

		// start - internal utility functions
		function stringExtract ( key ) {
			var math  = getMath( key );
			var value = ( ( math || {} ).value || {} ).id;

			if ( value === undefined ) {
				value = ERROR_MSGS.tplFormulaMissingPrefix;
			}

			if ( !math || ( !math.isNum && !math.isOptr ) ) {
				return '[:' + value + ':]';
			}
			return value;
		}

		function formulaComponentToString () {
			return self.ctrl.formula.map( stringExtract ).join( '' );
		}

		function checkFormulaCore ( callback ) {
			self.groupModel.formula = formulaComponentToString();
			self.status.msg = '';
			var validateMsg = '';

			( callback || angular.noop )( validateMsg );

			return validateMsg;
		}

		function broadcast ( validateMsg ) {
			$timeout( function () {
				if ( validateMsg === checkFormulaCore() ) {
					self.status.msg = validateMsg;
				}
			}, 2000 );
		}

		function checkFormula () {
			checkFormulaCore( broadcast );
		}

		function clearAllFilter ( math ) {
			return !math.isNum;
		}

		function clearAllFormula () {
			self.ctrl.formula = [];
			self.model        = self.model.filter( clearAllFilter );
		}

		function clearSingleFormula () {
			var popped = self.ctrl.formula.pop();

			self.model = self.model.filter( function ( math ) {
				return ( math.isNum && math.key !== popped ) || !math.isNum;
			} );
		}
		// end

		function initialize ( ctrl, model, groupModel, status ) {
			self.ctrl        = ctrl;
			self.model       = model;
			self.groupModel  = groupModel;
			self.status      = status;
		}

		function bindModel ( key, indicator ) {
			self.model.push( {
				'key'     : key,
				'value'   : indicator,
				'display' : key
			} );
		}

		function addToFormula ( key ) {
			self.ctrl.formula.push( key );
			checkFormula();
		}

		// adds number input into the formula element stack
		function addNumToModel ( numberId, value ) {
			formulaService.addNumToModel( self.model, numberId, value );
		}

		function addNumberToFormulaHandler ( value ) {
			var numberId = 'num' + self.ctrl.formula.length;

			addNumToModel( numberId, value );
			self.ctrl.formula.push( numberId );
			checkFormula();
		}

		function clear ( clearAll ) {
			if ( clearAll ) {
				clearAllFormula();
			} else {
				clearSingleFormula();
			}

			checkFormula();
		}

		self.addNumberToFormulaHandler = addNumberToFormulaHandler;

		self.addNumToModel = addNumToModel;
		self.addToFormula  = addToFormula;
		self.initialize    = initialize;
		self.bindModel     = bindModel;
		self.getMath       = getMath;
		self.clear         = clear;

		return self;
	}

	angular
		.module( 'app.components' )
		.service( 'mathService', MathService );

	MathService.$inject = [ 'formulaService', '$timeout', 'ERROR_MSGS' ];
} )();
